var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { AsciiText } from './framework/AsciiText';
import { Timeouts } from './framework/Timeouts';
export class NovastarVxSeries {
    constructor(socket, state, log, framework) {
        this.socket = socket;
        this.state = state;
        // other class properties and constructor
        this.timeouts = new Timeouts();
        this.busyTimeout = this.timeouts.create();
        // controls
        // Brightness implementation waiting for framework support.
        //public readonly brightness: WriteOnlyRangedControl<number> = {
        //    set: async (value: number, tags: Array<string>): Promise<number> => {
        //        await this.socket.send(
        //            this.makeCommand([
        //                0,
        //                0,
        //                0xfe,
        //                0xff,
        //                1,
        //                0xff,
        //                0xff,
        //                0xff,
        //                1,
        //                0,
        //                1,
        //                0,
        //                0,
        //                2,
        //                1,
        //                0,
        //                value,
        //            ]),
        //            /\xaa\x55\x00{2}\xff\xfe\x01\xff{3}\x01\x00\x01\x00{2}\x02\x00{2}\x54\x5a/,
        //            tags
        //        );
        //        return value;
        //    },
        //    range: { max: 255, min: 0, round: 1 },
        //};
        this.busy = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                return this.state.busy.value;
            }),
        };
        this.videoMatrixRoutes = {
            get: (key, tags) => __awaiter(this, void 0, void 0, function* () {
                return this.state.videoMatrixRoutes.values[key];
            }),
            set: (key, value, tags) => __awaiter(this, void 0, void 0, function* () {
                yield this.socket.send(this.makeCommand([
                    0,
                    0,
                    0xfe,
                    0,
                    0,
                    0,
                    0,
                    0,
                    1,
                    0,
                    0,
                    1,
                    0x51,
                    0x13,
                    1,
                    0,
                    parseInt(value, 10), // preset indices are zero-based
                ]), /\xaa\x55\x00{3}\xfe\x00{4}\x01\x00{2}\x01\x51\x13\x00{2}\xb9\x56/, tags);
                this.state.busy.update(true);
                this.busyTimeout.set(() => this.state.busy.update(false), 2000);
                return value;
            }),
        };
        // polling
        this.polls = [
            {
                intervalMs: 8000,
                function: () => __awaiter(this, void 0, void 0, function* () {
                    yield this.getModel(['poll', 'get.model']);
                }),
            },
        ];
    }
    // phase callbacks
    onConfigure(config) {
        return __awaiter(this, void 0, void 0, function* () {
            this.timeouts.clearAll();
        });
    }
    onDisconnect() {
        return __awaiter(this, void 0, void 0, function* () {
            this.timeouts.clearAll();
        });
    }
    onInitialize(credentials) {
        return __awaiter(this, void 0, void 0, function* () {
            // Query model id to verify device.
            const match = yield this.socket.send(this.makeCommand([0, 0, 0xfe, 0, 0, 0, 0, 0, 0, 0, 2, 0, 0, 0, 2, 0]), /\xaa\x55\x00{3}\xfe\x00{6}\x02\x00{3}\x02\x00([\s\S]{2})[\s\S]{2}/, ['initialize']);
            return match[0] === undefined ? 'verifyFailed' : 'connected';
        });
    }
    // other class methods
    makeCommand(data) {
        const checksum = data.reduce((sum, p) => sum + p, 0x5555);
        const bytes = [0x55, 0xaa, ...data, checksum & 0x00ff, (checksum & 0xff00) >> 8];
        return AsciiText.decode(bytes);
    }
    getModel(tags) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.socket.send(this.makeCommand([0, 0, 0xfe, 0, 0, 0, 0, 0, 0, 0, 2, 0, 0, 0, 2, 0]), /\xaa\x55\x00{3}\xfe\x00{6}\x02\x00{3}\x02\x00([\s\S]{2})[\s\S]{2}/, tags);
        });
    }
}
// static properties
NovastarVxSeries.driverType = 'socketDriver';
NovastarVxSeries.key = '-NQ6EJ1GRSsvcQVVX3w0';
NovastarVxSeries.socketOptions = [
    {
        commandExtractor: (buffer) => {
            for (let i = 0; i < buffer.length - 2; i++) {
                // responses start with 0x55 0x0a
                if (buffer.charCodeAt(i) === 0xaa &&
                    i < buffer.length - 1 &&
                    buffer.charCodeAt(i + 1) === 0x55) {
                    let checksum = 0x5555;
                    let j = i + 2;
                    while (j < buffer.length - 2) {
                        checksum += buffer.charCodeAt(j);
                        const checksumL = checksum & 0x00ff;
                        const checksumH = (checksum & 0xff00) >> 8;
                        if (checksumL === buffer.charCodeAt(j + 1) &&
                            checksumH === buffer.charCodeAt(j + 2)) {
                            const command = buffer.slice(i, j + 3); // include the checksum
                            buffer = buffer.slice(j + 3);
                            return { command, buffer };
                        }
                        j++;
                    }
                }
            }
            return undefined;
        },
        port: 5200,
        sendTerminator: '',
        isBinary: true,
    },
];
